const SELECTOR_ITEM = 'adv-container__label';
const SELECTOR_ITEM_ACTIVE = SELECTOR_ITEM+'--active';
const CHECKMARK_LIST = '.checkmarklist';

export default class Productpillar{

    constructor() {
        this.onClick = this.onClick.bind(this);
  
        let eles = document.getElementsByClassName(SELECTOR_ITEM);
        Array.from(eles).forEach(element => {     
            element.addEventListener('click', this.onClick);
        });
    }

    onClick(event) {
        let  el = event.target ; 
        el.classList.toggle(SELECTOR_ITEM_ACTIVE);
        
        let checklistEl = el.parentElement.nextElementSibling;
        checklistEl.classList.toggle('show');
    }
  
}







